import React, { memo } from "react";
import { AccordionButton, AccordionButtonProps } from "@chakra-ui/react";
import { ArrowDownIcon, ArrowRightIcon } from "modules/icons";
import colors from "app/colors";

const ExpandCollapseAccordionButton = ({
  canExpand,
  isExpanded,
  ...props
}: { canExpand: boolean; isExpanded: boolean } & AccordionButtonProps) => (
  <AccordionButton
    p={0}
    flex={0}
    fill={colors.orangePrimary}
    _hover={{ opacity: 0.6 }}
    _active={{ opacity: 0.4 }}
    opacity={canExpand ? 1 : 0}
    pointerEvents={canExpand ? "auto" : "none"}
    {...props}
  >
    {isExpanded ? (
      <ArrowDownIcon boxSize={6} />
    ) : (
      <ArrowRightIcon boxSize={6} />
    )}
  </AccordionButton>
);

export default memo(ExpandCollapseAccordionButton);
